export class StoreModelAction {
  create: boolean;
  read: boolean;
  update: boolean;
  delete: boolean;
  purchased: boolean;

  constructor() {
    this.create = false;
    this.read = false;
    this.update = false;
    this.delete = false;
    this.purchased = false;
  }
}
